import request from '@/utils/request.js'

async function getConfig() {
  if (sessionStorage.getItem('config') != null) {
    return JSON.parse(sessionStorage.getItem('config'))
  }
  const res = await request.post('/api/base/config')
  if (res.data.code == 0) {
    sessionStorage.setItem('config', JSON.stringify(res.data.data))
    return res.data.data;
  }
  throw new Error(res.data.message);
}

export default {
  getConfig
}